export default "__VITE_ASSET__BKRn4tLh__"